import { AxymaFooterDiv, Footer, FooterContainer, FooterDiv } from '../../Filling/FormFillingStyle';
import TicketSelectModal from '../../Filling/Modals/TicketSelectModal';
import { chamadoConfigType, FormToFilling } from '../../Filling/Types';
import { styleOptionsProp } from './NewFormFillingHeader';
import { Button, Stack } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Paragraph } from '../../Notifications/style/SingleNotificationStyle';

type params = {
  styleOptions: styleOptionsProp,
  chamadosConfig?: chamadoConfigType,
  checklist: FormToFilling;
  executa: Function,
  isLoading: boolean;
  itemToShow: number,
  setItemToShow: Function,
  onlyOneItem: boolean
};

export default function NewFormFillingFooter({
  styleOptions,
  chamadosConfig,
  checklist,
  executa,
  isLoading,
  itemToShow,
  setItemToShow,
  onlyOneItem
}: params) {

  const colorHeader = styleOptions?.colorHeader;

  return (
    <FooterContainer>
      <Footer
        style={{
          backgroundColor: colorHeader
            ? colorHeader
            : '#643E91'
        }}
      >
        <FooterDiv>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              {!onlyOneItem && <Button
                className='button is-white'
                variant='contained'
                disabled={itemToShow === 0}
                onClick={() => {
                  setItemToShow(itemToShow - 1);
                  window.scrollTo(0, 0);
                }}
              >
                <ArrowBackIosIcon />&nbsp;anterior
              </Button>}
              {
                itemToShow + 1 !== checklist?.itens?.length
                  ? <Button
                    onClick={() => {
                      setItemToShow(itemToShow + 1);
                      window.scrollTo(0, 0);
                    }}
                    className='button is-white'
                    variant='contained'>
                    Próximo&nbsp;<ArrowForwardIosIcon />
                  </Button>
                  : <Button
                    className='button is-success'
                    onClick={() => executa()}
                    disabled={isLoading}
                  >
                    Enviar&nbsp;
                    <GetAppIcon />
                  </Button>
              }
            </Stack>
          </Stack>
          <AxymaFooterDiv>
            <a
              href={'https://axyma.com.br/'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Paragraph style={{ textAlign: 'right' }}>Desenvolvido por Axyma&copy;</Paragraph>
            </a>
          </AxymaFooterDiv>
        </FooterDiv>
        {chamadosConfig
          && chamadosConfig?.tipoChamado?.length > 0
          && <TicketSelectModal />}
      </Footer>
    </FooterContainer>
  );
}